import React, {memo, useState, useCallback, useEffect, useRef} from 'react';
import {LFO, ENVELOPE} from 'constants/mod-types.js';
import { Arrow, Text, Circle, Group, Stage, Layer, FastLayer, Rect, Line} from 'react-konva';
import NodeIO from './NodeIO.js';
import {
    INPUT,
    OUTPUT,
    WIDTHS,
    NODE_WIDTH,
    NODE_COLOR,
    MODULATOR_COLOR,
    NODE_HEIGHT,
    NODE_HEIGHTS,
} from './constants.js';

const selectedColor = "red";

export default memo(({
    numberOfModulators,
    number,
    startDrawing,
    rack,
    setDragging,
    connectEdge,
    startDrawingEdge,
    setSelectedNodes,
    drawingEdge,
    width,
    height,
    modulator,
    selected,
    }) => 
{
    let y = 0;
    let x = 1.0 * (number + 1) / (numberOfModulators + 1) * width;
    let name = modulator.getType() === LFO ? 'LFO ' + modulator.number : 'Env ' + modulator.number;
    let nodeWidth = 35;

    const onMouseDown = useCallback(() => {
        setSelectedNodes([modulator]);
    }, [setSelectedNodes, modulator]);

    return (
        <g>
          <rect
            onMouseDown={onMouseDown}
            fill={selected ? "red" : MODULATOR_COLOR}
            x={x}
            y={y}
            width={nodeWidth}
            height={NODE_HEIGHT}/>
            <text
              onMouseDown={onMouseDown}
              className="modulator-node"
              fill={"white"}
              fontSize={10}
              fontFamily='Arial'
              x={x+3}
              y={y+10}
            >{name}</text>
          <NodeIO
            x={x}
            y={y}
            number={1}
            mode={OUTPUT}
            effect={modulator}
            setDragging={setDragging}
            connectEdge={connectEdge}
            isModulator={true}
            rack={rack}
            drawingEdge={drawingEdge}
            startDrawingEdge={startDrawingEdge}
          />
        </g>
    );
});
 
